import { render, staticRenderFns } from "./PolizasSAListView.vue?vue&type=template&id=264ed05a&"
import script from "./PolizasSAListView.vue?vue&type=script&lang=js&"
export * from "./PolizasSAListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports